import styles from "./AntiBriberyPolicyPage.module.css";

const AntiBriberyPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>ΠΟΛΙΤΙΚΗ ΓΙΑ ΤΗΝ ΚΑΤΑΠΟΛΕΜΗΣΗ ΤΗΣ ΔΩΡΟΔΟΚΙΑΣ</h1>
      <p>
        Η εταιρεία The Records Hub S.A. εφαρμόζει Σύστημα Διαχείρισης για την
        Αντιμετώπιση της Δωροδοκίας σύμφωνα με το πρότυπο ISO 37001:2025 έχοντας
        καθιερώσει διαδικασίες και κανονισμούς που αποτρέπουν και απαγορεύουν τη
        δωροδοκία στις εργασίες της στην Ελλάδα και στο εξωτερικό.
      </p>

      <h2>Το πεδίο εφαρμογής της εταιρείας είναι:</h2>
      <ul>
        <li>
          ΑΣΦΑΛΗ ΨΗΦΙΟΠΟΙΗΣΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ ΜΟΡΦΗ
        </li>
        <li>
          ΑΣΦΑΛΗ ΦΥΛΑΞΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
          ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ
        </li>
        <li>
          ΑΣΦΑΛΗΣ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
          ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ:
          <ul>
            <li>ΜΕΤΑΦΟΡΑ</li>
            <li>ΚΑΤΑΓΡΑΦΗ/ΚΑΤΑΛΟΓΟΓΡΑΦΗΣΗ</li>
            <li>ΑΡΧΕΙΟΘΕΤΗΣΗ</li>
            <li>
              ΠΡΟΕΠΙΣΚΟΠΙΣΗ ΚΑΙ ΑΝΑΖΗΤΗΣΗ ΜΕΤΑΔΕΔΟΜΕΝΩΝ ΣΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ
            </li>
          </ul>
        </li>
        <li>
          ΑΣΦΑΛΗ ΚΑΤΑΣΤΡΟΦΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
          ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ
        </li>
        <li>
          ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ (RECORDS
          MANAGEMENT) ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ
        </li>
        <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ DPO / GDPR</li>
      </ul>

      <h2>Δωροδοκία:</h2>
      <p>
        Προσφορά, υπόσχεση, χορήγηση, αποδοχή ή αίτηση οποιουδήποτε ανάρμοστου
        οφέλους με σκοπό την απόκτηση ή τη διατήρηση επιχειρηματικού
        πλεονεκτήματος ή την επήρεια της συμπεριφοράς ενός ατόμου με μη ηθικό
        τρόπο.
      </p>

      <h2>Όφελος:</h2>
      <p>
        Κάθε είδους δώρο, χρήματα, εξυπηρετήσεις, υπηρεσίες, προσφορές εργασίας
        ή οτιδήποτε μπορεί να θεωρηθεί ως αξία.
      </p>

      <h2>
        Οι διαδικασίες και οι κανονισμοί περί δωροδοκίας μεταφράζονται μεταξύ άλλων
        στους ακόλουθους κανόνες:
      </h2>
      <ul>
        <li>
          <strong>Η δωροδοκία απαγορεύεται αυστηρά.</strong> Αυτό σημαίνει ότι
          απαγορεύεται αυστηρά κάθε πράξη στην οποία προσφέρεται ή τιμολογείται κάτι
          που αξίζει (άμεσα ή έμμεσα) σε ένα άτομο για να παραπλανήσει το πρόσωπο
          αυτό, για παράδειγμα για να αποκτήσει ή να διατηρήσει ένα επιχειρηματικό
          πλεονέκτημα.
        </li>
        <li>
          <strong>Κάθε δώρο, δωρεά και φιλοξενία</strong> που προσφέρονται ή λαμβάνονται πρέπει
          να είναι εύλογα, ανάλογα και κατάλληλα υπό τις περιστάσεις και δεν θα
          μπορούσαν εύλογα να παρεξηγηθούν ως μέσο ή πρόθεση να επηρεάσουν
          εσφαλμένα τον παραλήπτη.
        </li>
        <li>
          <strong>Τα Λογιστικά βιβλία και τα αρχεία</strong> πρέπει να απεικονίζουν με ακρίβεια
          και έγκαιρα όλες τις συναλλαγές και άλλες επιχειρηματικές υποχρεώσεις
          σύμφωνα με τα ισχύοντα λογιστικά πρότυπα.
        </li>
        <li>
          <strong>Η δωροδοκία</strong> δεν είναι επιτρεπτή και πρέπει να αποφεύγεται
          ανά πάσα στιγμή.
        </li>
        <li>
          <strong>Η δωροδοκία</strong> σε κυβερνητικό αξιωματούχο με σκοπό να
          εξασφαλιστούν ή να επιταχυνθούν συνήθεις κυβερνητικές ενέργειες
          απαγορεύονται.
        </li>
        <li>
          Η εταιρεία δεν κάνει καμία <strong>συνεισφορά</strong>, σε χρήμα ή σε
          είδος, σε πολιτικά κόμματα ή πολιτικές οργανώσεις ή σε άτομα που
          ασχολούνται με την πολιτική.
        </li>
        <li>
          <strong>Οι φιλανθρωπικές συνεισφορές</strong> πρέπει να γίνονται μόνο σε
          καλόπιστους, εγκεκριμένους και νόμιμους οργανισμούς. Αυτό σημαίνει ότι οι
          συνεισφορές φιλανθρωπίας δεν μπορούν να γίνουν εάν εξασφαλίζουν ή θα
          μπορούσαν να θεωρηθούν ότι εξασφαλίζουν τυχόν αθέμιτα πλεονεκτήματα.
        </li>
        <li>
          Πρέπει να αποφεύγονται οι <strong>συγκρούσεις συμφερόντων</strong>. Μια
          σύγκρουση συμφερόντων προκύπτει όταν υπάρχει ιδιωτικό συμφέρον που θα
          μπορούσε να θέσει σε κίνδυνο την ικανότητά το ατόμου να ενεργεί προς το
          συμφέρον της εταιρείας.
        </li>
      </ul>

      <h2>Για να επιτύχει τα πιο πάνω, η Διεύθυνση της εταιρείας:</h2>
      <ul>
        <li>
          Έχει υιοθετήσει Σύστημα Διαχείρισης κατά της Δωροδοκίας σύμφωνα με το
          Διεθνές Πρότυπο ΙSO 37001:2025, το οποίο εφαρμόζει σε όλες τις
          δραστηριότητες της.
        </li>
        <li>
          Ανασκοπεί και βελτιώνει συνεχώς τις διαδικασίες κατά της Δωροδοκίας
          για την αποτελεσματικότητα του Συστήματος.
        </li>
        <li>
          Θέτει μετρήσιμους αντικειμενικούς σκοπούς και στόχους για την
          αντιμετώπιση της Δωροδοκίας τους οποίους αξιολογεί στα πλαίσια της
          ανασκόπησης του Συστήματος από τη Διεύθυνση της εταιρείας.
        </li>
        <li>
          Ενθαρρύνει το προσωπικό και τους συνεργάτες της να αναφέρουν οποιαδήποτε
          μορφή δωροδοκίας διασφαλίζοντας τους την εμπιστευτικότητα της αναφοράς
          τους και την προστασία τους χωρίς φόβο αντιποίνων ή κυρώσεων.
        </li>
        <li>
          Παρέχει τους απαραίτητους πόρους για την απρόσκοπτη, αποδοτική και
          αποτελεσματική αντιμετώπιση της Δωροδοκίας.
        </li>
        <li>
          Έχει καθιερώσει μία ανεξάρτητη Επιτροπή Αντιμετώπισης των περιπτώσεων
          Δωροδοκίας, η οποία διαθέτει την απαιτούμενη εξουσία, ανεξαρτησία και
          άμεση πρόσβαση στη Διοίκηση.
        </li>
        <li>
          Επενδύει στη συνεχή κατάρτιση, ενημέρωση και εκπαίδευση των στελεχών της
          κατά της Δωροδοκίας.
        </li>
      </ul>

      <p>
        Η μη συμμόρφωση της εταιρείας με τους νόμους κατά της δωροδοκίας και της
        διαφθοράς μπορεί να οδηγήσει σε σημαντικές κυρώσεις πρόστιμα και σοβαρές
        ζημιές στη φήμη της καθώς και σε πειθαρχικές κυρώσεις για το προσωπικό.
      </p>

      <p>
        Στη εταιρεία δεν ανεχόμαστε οποιαδήποτε μορφή δωροδοκίας και η πολιτική μας
        είναι να συμμορφωνόμαστε με όλους τους ισχύοντες νόμους και κανονισμούς για
        την καταπολέμηση της. Σε καμία περίπτωση δεν δίνουμε ή δεχόμαστε δωροδοκίες
        ή άλλα πλεονεκτήματα προς ή από οποιοδήποτε πρόσωπο, συμπεριλαμβανομένων
        κυβερνητικών αξιωματούχων, πελατών του ιδιωτικού τομέα, επιχειρηματικών
        συνεργατών ή πελατών.
      </p>

      <p>
        Η συμμόρφωση με τους νόμους και τις διαδικασίες κατά της δωροδοκίας
        αποτελεί ευθύνη όλων των εργαζομένων της εταιρείας σε όλες τις διαδικασίες
        και εργασίες. Η εταιρεία αναμένει το ίδιο και από όλους τους συνεργάτες της.
      </p>
    </div>
  );
};

export default AntiBriberyPolicyPage;
